import { DateTimeInput } from '../DateTimeInput'

import {
  TIME_INPUT_FORMAT_HINT,
  TIME_INPUT_FORMAT_MAX_LENGTH,
} from './TimeInput.constants'
import { formatTimeInputValue, parseTimeInputValue } from './TimeInput.utils'

import * as styles from './TimeInput.module.css'

function TimeInput({
  Component = DateTimeInput,
  maxValue,
  minValue,
  wrapperClassName = styles.TimeInputWrap,
  ...componentProps
}) {
  function parse(string) {
    return parseTimeInputValue(string, { maxValue, minValue })
  }

  return (
    <Component
      {...componentProps}
      format={formatTimeInputValue}
      formatHint={TIME_INPUT_FORMAT_HINT}
      maxLength={TIME_INPUT_FORMAT_MAX_LENGTH}
      parse={parse}
      wrapperClassName={wrapperClassName}
    />
  )
}

export default TimeInput
